import { type ReactNode } from "react";
import { useScreenWidth } from "@app/dashboard/hooks/useScreenWidth";
import { t } from "i18next";
import type { IIframeCard } from "@app/dashboard/types/innerLayout/iframes/iframe-card";
import { TrashCan, Pen, Copy, ArrowUpRightFromSquare } from "@unified-checkout/design-system/icons/index";
import { Button } from "@unified-checkout/design-system";
import styles from "./Iframe-card.module.scss";

export const IframeCard = ({
  width,
  height,
  title,
  itemsList,
  actions,
  disabled = false,
  selectedIframeId
}: IIframeCard) => {

  const screenWidth = useScreenWidth();
  const isDesktop = screenWidth >= 1200;

  const hasActions = actions &&
    (
      actions.onEdit ||
      actions.onDelete ||
      actions.onDuplicate ||
      actions.onPreview
    );

  return (
    <div
      className={styles["iframe-card"]}
      style={{ width, height }}
    >
      <div className={styles["iframe-card__header"]}>
        {title && (
          <div className={styles["iframe-card__header__title"]}>
            {title}
          </div>
        )}
        {hasActions && (
          <div className={styles["iframe-card__header__actions"]}>
            {actions.onDelete && (
              <Button
                size="sm"
                type="button"
                onClickHandler={actions.onDelete}
                color="secondary"
                variant="outlined"
                leadingIcon={TrashCan}
                disabled={disabled}
              />
            )}
            {actions.onEdit && (
              <Button
                size="sm"
                color="secondary"
                variant="outlined"
                leadingIcon={Pen}
                onClickHandler={actions.onEdit}
                disabled={disabled}
              />
            )}
            {actions.onDuplicate && (
              <Button
                size="sm"
                color="primary"
                text={isDesktop ? t('innerLayout.iFramesPage.iframeCard.duplicate') : ""}
                variant="contained"
                onClickHandler={actions.onDuplicate}
                leadingIcon={Copy}
                disabled={disabled}
              />
            )}

            {actions.onPreview && (
              <Button
                size="sm"
                color="secondary"
                text={isDesktop ? t('innerLayout.iFramesPage.iframeCard.preview') : ""}
                variant="outlined"
                leadingIcon={ArrowUpRightFromSquare}
                onClickHandler={actions.onPreview}
                disabled={disabled}
                loading={selectedIframeId}
              />
            )}

          </div>
        )}
      </div>

      <div className={styles["iframe-card__body"]}>
        {itemsList?.map((item, index) => (
          <div
            className={styles["iframe-card__body__item"]}
            key={`iframe-card-item-${index}`}
          >
            {item.label && (
              <div className={styles["iframe-card__body__item__label"]}>
                {item.label}
              </div>
            )}
            {item.value && (
              <div
                className={styles["iframe-card__body__item__value"]}
              >
                {item.value}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
